module.exports = __webpack_public_path__ + "img/default-image.e50616fb.jpg";